import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
// import { updateActivityGrade } from "../../../../Store/api/professor/dashboard";

// eslint-disable-next-line no-lone-blocks
{
  /* TODO: Dont remove any code from this component its done functionality and will uncomment after MVP release */
}

export const GradeCard = ({
  per,
  expired,
  activity,
  due,
  index: sectionIndex,
  _index: studentIndex,
}) => {
  const dispatch = useDispatch();
  const popUpRef = useRef(null);
  const [show, setShow] = useState(false);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleToggle = () => {
  //   setShow(true);
  //   setToggle(prev => !prev)
  // };

  const handleClickOutside = (event) => {
    if (popUpRef.current && !popUpRef.current.contains(event.target)) {
      setShow(false);
      setToggle(false);
    }
  };

  // const handleGradeUpdate = () => {
  //   dispatch(updateActivityGrade({}))
  // };

  return (
    <>
      {/* <td className="p-0 position-relative overflow-visible" ref={popUpRef} onDoubleClick={handleToggle}> */}
      <td className="p-0 position-relative">
        {/* {show &&
          <div className={`d-flex flex-column justify-content-center grade-container position-absolute w-200 ${(sectionIndex === 0 && studentIndex === 0) ? 'top-100': 'bottom-100'} h-auto gap-12 zIndex p-12`}>
            <p className="mb-0 fs-14 text-uppercase fw-500">Mass Change Grade</p>
            <div className="d-flex justify-content-center align-items-center h-70 border-grey-600">
              <input type="text" value={per} className="w-25 border-0 text-center" readOnly />%
            </div>
            <button type="button" className="cursor save-btn text-uppercase text-grey-800 rounded-0 fw-500 fs-14">
              Confirm Grade
            </button>
          </div>
        } */}
        {/* {toggle ?
          <input autoFocus type="text" className="w-100 h-100 border-grey-600 text-center fw-semibold fs-6 border-3" />:
          <div className={`d-flex gap-1 justify-content-center align-items-center grad-column ${per === 100 ? "" : (expired && activity?.questionStatus !== "Completed") ? "border-red": (due && activity?.questionStatus === 'InProgress')? "border-yellow": ""}`} style={{ padding: "3px 6px"}}>
            <p className={`graded-section-column mb-0 ${(expired && activity?.questionStatus !== "Completed") ? "text-red": (due && activity?.questionStatus === 'InProgress')? "text-yellow-900": ""}`}>
              {per === null ? "--" : Math.round(per)}%
            </p>
          </div>
        } */}
        {per === null ? "--" : Math.round(per)}%
      </td>
    </>
    // TODO: Dont remove bellow jsx...
    // <td key={indx} className="p-0">
    //   <div className={`d-flex gap-1 justify-content-center align-items-center grad-column ${per === 100 ? "" : (expired && activity?.questionStatus !== "Completed") ? "border-red": (due && activity?.questionStatus === 'InProgress')? "border-yellow": ""}`} style={{ padding: "3px 6px"}}>
    //     <p className={`graded-section-column mb-0 ${(expired && activity?.questionStatus !== "Completed") ? "text-red": (due && activity?.questionStatus === 'InProgress')? "text-yellow-900": ""}`}>
    //       {(due && activity?.questionStatus !== "Completed") ? "--" : Math.round(per)}%
    //     </p>
    //   </div>
    // </td>
  );
};
